import { useEffect } from 'react';

import type { CookieChangeListener } from 'universal-cookie';

import { CookieManager } from '@/_shared';

type UseAuthTokenListenerParams = {
  onAuthenticated: () => void;
  onUnauthenticated: () => void;
};

/**
 * Listens for AUTH_TOKEN cookie changes and notifies when the session appears or disappears.
 */
export function useAuthTokenListener({ onAuthenticated, onUnauthenticated }: UseAuthTokenListenerParams) {
  useEffect(() => {
    const listenCookiesChange: CookieChangeListener = (cookie) => {
      if (!cookie?.name || !CookieManager.matchKeys(cookie.name, CookieManager.AUTH_TOKEN)) {
        return;
      }

      if (CookieManager.getAccessToken()) {
        onAuthenticated();
        return;
      }

      onUnauthenticated();
    };

    CookieManager.cookies.addChangeListener(listenCookiesChange);

    return () => {
      CookieManager.cookies.removeChangeListener(listenCookiesChange);
    };
  }, [onAuthenticated, onUnauthenticated]);
}
